import { useState, useCallback, type ReactElement } from 'react';
import { StepUpModal, type StepUpRequest } from './StepUpModal';

interface PendingPromise {
  resolve: (token: string) => void;
  reject: (err: Error) => void;
}

interface UseStepUp {
  // Ruft das Step-up-Modal auf, gibt das Token zurück sobald der Admin
  // bestätigt hat. Wird das Modal abgebrochen, rejected die Promise.
  request: (req: StepUpRequest) => Promise<string>;
  // Render-Helper: in den Render-Tree einsetzen, damit das Modal erscheinen
  // kann.
  modal: ReactElement | null;
}

export function useStepUp(): UseStepUp {
  const [active, setActive] = useState<{ req: StepUpRequest; pending: PendingPromise } | null>(
    null,
  );

  const request = useCallback((req: StepUpRequest): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      setActive({ req, pending: { resolve, reject } });
    });
  }, []);

  const modal: ReactElement | null = active ? (
    <StepUpModal
      request={active.req}
      onConfirm={(token) => {
        active.pending.resolve(token);
        setActive(null);
      }}
      onCancel={() => {
        active.pending.reject(new Error('Bestätigung abgebrochen'));
        setActive(null);
      }}
    />
  ) : null;

  return { request, modal };
}
